var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.18689C2.60406 6.08717 2.91537 4.77804 3.84664 3.84676C4.77792 2.91549 6.08705 2.60418 8.18677 2.50012M21.5 8.18689C21.3959 6.08717 21.0846 4.77804 20.1534 3.84676C19.2221 2.91549 17.9129 2.60418 15.8132 2.50012M15.8132 21.5001C17.9129 21.396 19.2221 21.0847 20.1534 20.1535C21.0846 19.2222 21.3959 17.913 21.5 15.8133M8.18676 21.5001C6.08705 21.396 4.77792 21.0847 3.84664 20.1535C2.91537 19.2222 2.60406 17.913 2.5 15.8133",
    stroke: "#F2FCF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49902 10.5563C9.49902 9.71463 9.36683 8.4152 9.87504 7.65752C10.9975 5.984 13.379 6.20631 14.219 7.8398C14.6313 8.64152 14.4759 9.76238 14.495 10.5563M9.49902 10.5563C8.20169 10.5563 7.93745 11.299 7.73904 11.8815C7.55589 12.5368 7.36944 14.1015 7.65504 15.816C7.86871 16.9082 8.70381 17.3886 9.42199 17.4495C10.1088 17.5077 13.0087 17.4855 13.8482 17.4855C15.1491 17.4855 15.9614 17.1995 16.343 15.8888C16.5262 14.8694 16.5763 13.0465 16.271 11.8815C15.8666 10.7164 15.0513 10.5563 14.495 10.5563M9.49902 10.5563C10.8726 10.5018 13.7097 10.5126 14.495 10.5563",
    stroke: "#F2FCF7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/Privacy-Policy.539c96e91505ae9a9fd0bc420ae80c7d.svg";
export { ForwardRef as ReactComponent };